<template>
  <div class="login">
    <div class="login-box">
      <v-tooltip v-model="show" bottom>
        <template v-slot:activator="{ on }">
          <img :src="brand.logo" alt="Logo Gestão Afiliados" class="logo mb-5" />
          <span class="d-flex justify-center mb-2"> {{ $t('auth.changePassword') }}</span>
        </template>
      </v-tooltip>


      <!-- <v-toolbar-title 
        style="
        font-size: 31px;
        text-align: center;
        width: 100%;
        color: rgb(255, 255, 255);
        font-weight: 100;
        text-transform: uppercase;
        margin-bottom: 1.3rem;
        position: relative;
        z-index: 999999
        ">
        Gestao 
      <v-tooltip v-model="show" right>
        <template v-slot:activator="{ on }">
          <strong @mouseover="show = true" @mouseout="show = false" style="font-weight: 800;"> Única </strong>
        </template>
        <span> v.{{ appVersion }}</span>
      </v-tooltip>

    </v-toolbar-title> -->
     
      <v-card class="card-login">
        <v-form>
          <v-card-text>
            <v-text-field 
              class="item"
              color="white"
              outlined
              filled
              :type="showPassword ? 'text' : 'password'" 
              :label="$t('auth.newPassword')"
              prepend-inner-icon="mdi-key"
              v-model="user.password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"  
              :error-messages="nameErrors"
              @input="$v.user.password.$touch()"
              @blur="$v.user.password.$touch()" />

            <v-text-field 
              class="item"
              color="white"
              outlined
              filled
              :type="showPassword ? 'text' : 'password'" 
              :label="$t('auth.confirmPassword')"
              prepend-inner-icon="mdi-key"
              v-model="user.confirmPassword"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              dense
              :error-messages="confirmPasswordErrors"
              @input="$v.user.confirmPassword.$touch()" 
              @blur="$v.user.confirmPassword.$touch()" />

            <!-- <div class="text-right ">
              <a class="login-esqueci-senha-btn mb-2" @click.prevent="showRecoverPasswordModal">Esqueci minha senha</a>
            </div> -->

          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn type="submit" color="primary" @click.prevent="submit" class="login-btn" tile :loading="loading">{{ $t('auth.changePassword') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </div>

    <BrSnackbar :snackbar="snackbar" />
    <recoverPasswordModal/>
    <newPasswordModal/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'
// import newPasswordModal from './components/modalNewPassword'
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import variables from '@/assets/styles/helpers/_variables.scss'
import brand from '@/core/brand'

export default {
  name: 'Login',
  mixins: [validationMixin],
  components: {
    BrSnackbar: () => import('@/views/components/snackbar'),
    // recoverPasswordModal: () => import ('./components/modalRecoverPassword'),
    // newPasswordModal
  },

  data: () => ({
    show: false,
    snackbar: {
      toggle: false,
      type: null,
      msg: null
    },
    loading: false,
    showPassword: false,
    valid: true,
    token: '',
    user: {
      password: '',
      confirmPassword: '',
    }
  }),
  
  mounted(){
    this.showNewPasswordModal()
  },
  computed: {
    variables: () => variables,
    brand: () => brand,
    appVersion () {
      return process.env.VUE_APP_VERSION
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.user.password.$dirty) return errors
      !this.$v.user.password.required && errors.push(this.$t('auth.passwordRequired'))
      return errors
    },

    confirmPasswordErrors () {
      const errors = []
      if (!this.$v.user.confirmPassword.$dirty) return errors
      !this.$v.user.confirmPassword.required && errors.push(this.$t('auth.passwordRequired'))
      !this.$v.user.confirmPassword.sameAsPassword && errors.push(this.$t('auth.passwordsDontMatch'))
      return errors
    },
  },

  methods: {
    ...mapActions('auth', ['recoverPassword']),
    submit () {
      const self = this

      if (this.$v.user.$invalid || (this.user.password != this.user.confirmPassword)) { 
        this.$v.user.$touch()
        this.loading = false
        return false 
      }

      self.recoverPassword({token: this.token, password: this.user.password, confirmPassword: this.user.confirmPassword}).then(() => {
        this.loading = false
        successSnackbar(this.$t('auth.senhaAlterada'))
        self.$router.replace('/auth')
        return true
      }).catch(e => {
        this.loading = false
        errorSnackbar(e.erro)
        return false
      })
    },

    showNewPasswordModal(){
      this.token = this.$router.currentRoute.query.token

      if (!this.token) this.$router.push('/auth')
    }
  },

  validations () {
    return {
      user: {
        confirmPassword: { required, sameAsPassword: sameAs('password') },
        password: { required }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/auth';
  .card-login::v-deep {
    .v-text-field__details {
      display: block !important;
    }
  }

</style>